/* eslint-disable react/jsx-no-useless-fragment */
import * as am5 from '@amcharts/amcharts5';
import * as am5xy from '@amcharts/amcharts5/xy';
import am5themes_Animated from '@amcharts/amcharts5/themes/Animated';
import React, { useEffect } from 'react';

const MultipleLines = (props) => {
	const { data, id } = props;

	useEffect(() => {
		const root = am5.Root.new(id);

		console.log(data);

		// Set themes
		// https://www.amcharts.com/docs/v5/concepts/themes/
		root.setThemes([
			am5themes_Animated.new(root),
		]);

		// Create chart
		// https://www.amcharts.com/docs/v5/charts/xy-chart/
		const chart = root.container.children.push(am5xy.XYChart.new(root, {
			panX: true,
			panY: true,
			wheelX: 'panX',
			wheelY: 'zoomX',
			pinchZoomX: true,
		}));

		// Add cursor
		// https://www.amcharts.com/docs/v5/charts/xy-chart/cursor/
		const cursor = chart.set('cursor', am5xy.XYCursor.new(root, {
			behavior: 'none',
		}));
		// cursor.lineY.set('visible', false);

		// Create axes
		// https://www.amcharts.com/docs/v5/charts/xy-chart/axes/
		const xAxis = chart.xAxes.push(am5xy.ValueAxis.new(root, {
			// min: Number(minX) - Number(maxX) / 10,
			// max: Number(maxX) + Number(maxX) / 10,
			// min: 0,
			// max: data.maxX,
			// strictMinMax: true,
			renderer: am5xy.AxisRendererX.new(root, {}),
			tooltip: am5.Tooltip.new(root, {}),
		}));

		const yAxis = chart.yAxes.push(am5xy.ValueAxis.new(root, {
			// min: Number(minY) - Number(maxX) / 10,
			// max: Number(maxY) + Number(maxX) / 10,
			// min: 0,
			// max: data.maxY,
			// strictMinMax: true,
			renderer: am5xy.AxisRendererY.new(root, {}),
		}));

		xAxis.children.moveValue(am5.Label.new(root, {
			text: data.label,
			x: am5.p50,
			centerX: am5.p50,
		}), xAxis.children.length - 1);

		yAxis.children.moveValue(am5.Label.new(root, {
			rotation: -90,
			text: 'Frequency',
			y: am5.p50,
			centerX: am5.p50,
		}), 0);

		const assignColor = (category) => {
			switch (category) {
			case 'Limited Conflict': return 'rgba(115,169,143,0.3)';
			case 'Moderate Conflict': return 'rgba(246,224,159,0.3)';
			case 'High Conflict': return 'rgba(230,151,138,0.30)';
			default: return '#fff';
			}
		};

		const assignStrokeColor = (category) => {
			switch (category) {
			case 'Limited Conflict': return 'rgba(115,169,143,1)';
			case 'Moderate Conflict': return 'rgba(246,224,159,1)';
			case 'High Conflict': return 'rgba(230,151,138,1)';
			default: return '#fff';
			}
		};

		data.chartData.map((item) => {
			const series = chart.series.push(am5xy.StepLineSeries.new(root, {
				name: item.category,
				xAxis,
				yAxis,
				// valueYField: 'frequency',
				// valueXField: 'bucket',
				valueYField: 'density',
				valueXField: 'value',
				fill: assignColor(item.category),
				stroke: assignStrokeColor(item.category),
				tooltip: am5.Tooltip.new(root, {
					labelText: '{valueY}',
				}),
			}));

			series.strokes.template.setAll({
				// templateField: 'strokeSettings',
				visible: true,
				strokeWidth: 2,
			});

			series.fills.template.setAll({
				fillOpacity: 0.6,
				visible: true,
			});

			// let index = item.data.length - 1;
			// let flag = true;
			// while (flag && index > 0) {
			// 	if (item.data[index].density === 1) {
			// 		index -= 1;
			// 	} else {
			// 		flag = false;
			// 	}
			// }
			// const newData = [];
			// // eslint-disable-next-line no-plusplus
			// for (let i = 0; i <= index; i++) {
			// 	newData.push(item.data[i]);
			// }

			series.data.setAll(item.data);
			series.appear();
		});

		const legend = chart.rightAxesContainer.children.push(am5.Legend.new(root, {
			width: 200,
			paddingLeft: 15,
			height: am5.percent(100),
		}));

		// When legend item container is hovered, dim all the series except the hovered one
		legend.itemContainers.template.events.on('pointerover', (e) => {
			const itemContainer = e.target;

			// As series list is data of a legend, dataContext is series
			const series = itemContainer.dataItem.dataContext;

			chart.series.each((chartSeries) => {
				if (chartSeries != series) {
					chartSeries.strokes.template.setAll({
						strokeOpacity: 0.15,
						stroke: am5.color(0x000000),
					});
				} else {
					chartSeries.strokes.template.setAll({
						strokeWidth: 3,
					});
				}
			});
		});

		// When legend item container is unhovered, make all series as they are
		legend.itemContainers.template.events.on('pointerout', (e) => {
			const itemContainer = e.target;
			const series = itemContainer.dataItem.dataContext;

			chart.series.each((chartSeries) => {
				chartSeries.strokes.template.setAll({
					strokeOpacity: 1,
					strokeWidth: 1,
					stroke: chartSeries.get('fill'),
				});
			});
		});

		legend.itemContainers.template.set('width', am5.p100);
		legend.valueLabels.template.setAll({
			width: am5.p100,
			textAlign: 'right',
		});

		legend.data.setAll(chart.series.values);

		chart.appear(1000, 100);

		return () => root.dispose();
	}, [data]);

	return (
		<div id={id} style={{ width: '100%', height: '500px' }} />
	);
};
export default MultipleLines;
